<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">凭证列表</span></div>
		<div class="margin-right-left margin-top">
			<Row type="flex" :space-x="10" class="filter-bar">
				<Cell>
					<span class="filter-label">期间</span>
					<account-date-multi-choose v-model="periods"/>
				</Cell>
				<Cell>
					<span class="filter-label">凭证字</span>
					<Select multiple :datas="voucherWords" keyName="word" titleName="word" v-model="filterWords" style="min-width: 130px"/>
				</Cell>
				<Cell>
					<span class="filter-label">凭证号</span>
					<input class="filter-input" v-model="codeBegin" placeholder="起" style="width: 70px"/>
					<span class="sep">-</span>
					<input class="filter-input" v-model="codeEnd" placeholder="止" style="width: 70px"/>
				</Cell>
				<Cell>
					<span class="filter-label">摘要</span>
					<input class="filter-input" v-model="summary" placeholder="摘要关键字" style="width: 140px" @keyup.enter="doSearch"/>
				</Cell>
				<Cell>
					<span class="filter-label">审核</span>
					<Select :datas="auditOptions" keyName="value" titleName="title" v-model="auditStatus" style="min-width: 100px"/>
				</Cell>
				<Cell>
					<span class="filter-label">科目</span>
					<DropdownCustom ref="subjectDropdown" :toggleIcon="false">
						<div class="subject-trigger">
							<span>{{subjectName || '全部科目'}}</span>
							<i class="fa fa-caret-down"></i>
						</div>
						<div class="subject-panel" slot="content">
							<Tree v-model="subjectId" @select="subjectSelect" :option="subjectOption" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
						</div>
					</DropdownCustom>
				</Cell>
				<Cell>
					<Button @click="doSearch">查询</Button>
					<Button @click="resetFilter">重置</Button>
				</Cell>
			</Row>
		</div>
		<div class="margin-right-left">
			<div class="float-right">
				<template v-if="User.role!=='View' && currentAccountSets.voucherReviewed">
					<Button :loading="loading" @click="audit">审核</Button>
					<Button :loading="loading" @click="cancelAudit">取消审核</Button>
				</template>
				<DropdownMenu button @click="trigger" :datas="param">打印</DropdownMenu>
				<template v-if="User.role!=='View'">
					<Button :loading="loading" @click="finishingOffNo">整理断号</Button>
					<Button :loading="loading" @click="batchDelete">批量删除</Button>
					<Button :loading="loading" @click="doUpload">
						<input ref="file" type="file" accept="application/vnd.ms-excel" style="display: none" @change="fileChange($event)">
						导入凭证
					</Button>
				</template>
			</div>
		</div>
		<div class="h-panel-body">
			<table class="header">
				<tr>
					<th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
					<td style="width: 215px">摘要</td>
					<td>科目</td>
					<td align="right" style="width: 130px">借方金额</td>
					<td align="right" style="width: 130px">贷方金额</td>
				</tr>
			</table>
			<table v-if="!datas.length">
				<tr>
					<td colspan="5" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table class="details" v-for="data in datas" :key="data.id">
				<tr class="details-header">
					<th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
					<td colspan="2">日期：{{data.voucherDate}} 凭证字号：{{data.word}}-{{data.code}}</td>
					<td colspan="2" class="actions" align="right">
						<router-link v-if="data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">查看</router-link>
						<a :href="`/api/pfd/voucher?id=${data.id}`" target="_blank">打印</a>
						<router-link v-if="User.role!=='View'" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
						<span v-if="User.role!=='View'" @click="remove(data)">删除</span>
						<i v-if="data.auditMemberId" class="h-icon-completed green-color" v-tooltip content="已审核"></i>
					</td>
				</tr>
				<tr v-for="d in data.details" :key="d.id">
					<th></th>
					<td style="width: 215px">
						{{d.summary}}
						<template v-if="d.subject&&d.num&&d.price">
							(数量:{{d.num}}<span class="dark4-color">{{d.subject.unit}}</span>，单价:{{d.price}}<span class="dark4-color">元</span>)
						</template>
					</td>
					<td>{{d.subjectName}}</td>
					<td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
					<td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
				</tr>
				<tr class="font-bold">
					<td></td>
					<td>合计</td>
					<td>{{data.debitAmount|dxMoney}}</td>
					<td align="right">{{data.debitAmount|numFormat}}</td>
					<td align="right">{{data.creditAmount|numFormat}}</td>
				</tr>
			</table>
			<Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
		</div>
	</app-content>
</template>

<script>
	import Qs from "qs";
	import moment from 'moment'
	import {mapState} from 'vuex'

	export default {
		name: "Voucher",
		data() {
			return {
				datas: [],
				periods: [],
				filterWords: [],
				codeBegin: null,
				codeEnd: null,
				summary: null,
				auditStatus: '',
				subjectId: null,
				subjectCode: null,
				subjectName: null,
				voucherWords: [],
				auditOptions: [{title: '全部', value: ''}, {title: '未审核', value: '0'}, {title: '已审核', value: '1'}],
				subjectOption: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'subjectFullName',
					dataMode: 'list',
					datas: []
				},
				pagination: {
					page: 1,
					total: 0
				},
				loading: false,
				checkAll: false,
				param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
			};
		},
		watch: {
			checkAll(nval) {
				let data = Array.from(this.datas);
				data.forEach(val => val._checked = nval);
				this.datas = data;
			},
			periods() {
				this.pagination.page = 1;
				this.loadList();
			}
		},
		computed: {
			...mapState(['User', 'currentAccountSets'])
		},
		methods: {
			currentChange() {
				this.loadList();
			},
			trigger(key) {
				this[key].call(this);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			resetFilter() {
				this.filterWords = [];
				this.codeBegin = null;
				this.codeEnd = null;
				this.summary = null;
				this.auditStatus = '';
				this.subjectId = null;
				this.subjectCode = null;
				this.subjectName = null;
				this.doSearch();
			},
			subjectSelect(node) {
				this.subjectId = node.id;
				this.subjectCode = node.code;
				this.subjectName = node.subjectFullName;
				if (this.$refs.subjectDropdown) {
					this.$refs.subjectDropdown.hide();
				}
			},
			printAll() {
				if (this.periods.length === 1) {
					let ym = this.periods[0].split('-');
					let param = Qs.stringify({year: ym[0], month: ym[1]}, {indices: false});
					window.open(`/api/pfd/voucher?${param}`);
				} else {
					this.periods.forEach((p, i) => {
						let ym = p.split('-');
						setTimeout(() => {
							window.open(`/api/pfd/voucher?year=${ym[0]}&month=${ym[1]}`);
						}, i * 400);
					});
				}
			},
			printCheck() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
					window.open(`/api/pfd/voucher?${param}`);
				} else {
					this.$Message("未选择记录");
				}
			},
			loadList() {
				let params = {page: this.pagination.page};
				if (this.periods.length) {
					params.periods = this.periods.join(',');
				}
				if (this.filterWords.length) {
					params.words = this.filterWords.join(',');
				}
				if (this.codeBegin) {
					params.codeBegin = this.codeBegin;
				}
				if (this.codeEnd) {
					params.codeEnd = this.codeEnd;
				}
				if (this.summary) {
					params.summary = this.summary;
				}
				if (this.auditStatus !== '') {
					params.auditStatus = this.auditStatus;
				}
				if (this.subjectCode) {
					params.subjectCode = this.subjectCode;
				}
				this.$api.voucher.list(params).then(({data}) => {
					this.datas = data.records;
					this.pagination = {
						page: data.current,
						size: data.size,
						total: data.total
					}
				})
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.voucher.delete(data.id).then(() => {
						this.loadList();
					})
				});
			},
			finishingOffNo() {
				this.loading = true;
				let chain = Promise.resolve();
				this.periods.forEach(p => {
					let ym = p.split('-');
					chain = chain.then(() => this.$api.voucher.finishingOffNo({year: ym[0], month: ym[1]}));
				});
				chain.then(() => {
					this.loadList();
				}).finally(() => {
					this.loading = false;
				});
			},
			batchDelete() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("确认删除?").then(() => {
						this.loading = true;
						this.$api.voucher.batchDelete({checked: checked.map(value => value.id)}).then(() => {
							this.loadList();
						}).finally(() => {
							this.loading = false
						});
					});
				}
			},
			audit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.audit({checked: checked.map(value => value.id)}).then(() => {
							this.loadList();
							this.$Message("审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			cancelAudit() {
				let checked = this.datas.filter(value => value._checked);
				if (checked.length) {
					this.$Confirm("亲，确认要取消审核吗?").then(() => {
						this.loading = true;
						this.$api.voucher.cancelAudit({checked: checked.map(value => value.id)}).then(() => {
							this.loadList();
							this.$Message("取消审核成功！");
						}).finally(() => {
							this.loading = false;
						});
					});
				} else {
					this.$Message("未选择记录");
				}
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.voucher.import(formData).then(({data}) => {
						if (data) {
							this.periods = [moment(data).format('YYYY-M')];
						}
						this.$store.dispatch('init');
						this.$Message("亲,导入成功~");
					}).finally(() => {
						this.loading = false;
					});

					this.$refs.file.value = "";
				}
			}
		},
		mounted() {
			if (!this.periods.length && this.currentAccountSets && this.currentAccountSets.currentAccountDate) {
				this.periods = [moment(this.currentAccountSets.currentAccountDate).format('YYYY-M')];
			}
			this.$api.setting.voucherWord.list().then(({data}) => {
				this.voucherWords = data || [];
			});
			this.$api.setting.subject.tree().then(({data}) => {
				this.$set(this.subjectOption, 'datas', data || []);
			});
		}
	}
</script>
<style lang='less' scoped>
	.filter-bar {
		margin-bottom: 10px;

		// HeyUI Cell 实际渲染类名是 .h-col（.cell 不命中，导致筛选控件基线错位）
		.h-col {
			display: flex;
			align-items: center;
		}

		.filter-label {
			margin-right: 6px;
			color: @dark3-color;
		}

		.sep {
			margin: 0 4px;
			color: @gray2-color;
		}

		.filter-input {
			height: 30px;
			border: 1px solid @border-color;
			border-radius: @border-radius;
			padding: 0 8px;
			font-size: 13px;
			color: @dark2-color;
			outline: none;
			background: #fff;
			box-sizing: border-box;

			&::placeholder {
				color: @gray2-color;
			}

			&:focus {
				border-color: @primary-color;
			}
		}
	}

	.subject-trigger {
		background: @primary-color;
		color: @white-color;
		cursor: pointer;
		border-radius: @border-radius;
		padding: 5px 10px;
		display: flex;
		align-items: center;
		max-width: 160px;

		span {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.fa {
			margin-left: 8px;
		}
	}

	.subject-panel {
		width: 280px;
		height: 400px;
		overflow-y: auto;
	}

	.h-panel-body {
		table {
			width: 100%;
			border-collapse: collapse;

			td {
				padding: 7px;
			}

			&.header {
				background-color: @primary-color;
				color: white;
			}
		}

		.details {
			font-size: 12px;
			margin: 15px 0;
			border: 1px solid @gray2-color;

			.actions {
				text-align: right;
				padding-right: 20px;

				span, a {
					display: none;
				}
			}

			input {
				display: none;

				&.display {
					display: inline-block;
				}
			}

			&-header {
				background-color: @gray3-color;
				color: @dark3-color;
			}

			td, th {
				border-bottom: 1px solid @gray2-color;
			}

			tr:hover:not(.details-header) {
				background-color: #dff7df;
				cursor: pointer;
			}

			&:hover {
				box-shadow: 0 0 10px 0 #dadada;
				border-color: #dadada;

				.actions {
					span, a {
						display: inline-block;
					}
				}

				input {
					display: inline-block;
				}
			}
		}
	}
</style>
